import './OurTeam.css';

const OurTeam = () => {
  return (
    <section className='ourteam container' id='ourteam_section'>
      <div className='blur-wrap'>
        <h2 className='ourteam-header lancaster-color'>Contáctanos</h2>
        <p className='ourteam-paragraph'>
          Nuestra prioridad es la atención. Nos enfocamos en la calidad, en
          alcanzarla y mantenerla. Nuestro objetivo es ayudarte a
          cumplir tus objetivos y asegurar la satisfacción de todos.
        </p>
        <a
          href="https://wa.me/528112557887?text=Hola,%20quiero%20saber%20más%20sobre%20Lancaster"
          className='ourteam-button'
          alt='Contáctanos por Whatsapp'
        >
          Mándame un mensaje
        </a>
      </div>
    </section>
  );
};

export default OurTeam;
